import { env } from "~/env";

export const appConstants = {
  mfoNameShort: env.VITE_MFO_NAME_SHORT,
  mfoNameLong: env.VITE_MFO_NAME_LONG,
  juicyRegion: env.VITE_JUICY_REGION,
  juicyApiKey: env.VITE_JUICY_API_KEY,
};
